<template>
  <div class="footer">
    <container>
      <colofon-social />
      <div class="content">
        <p class="block">
          <strong>Verantwoording</strong><br>
          Yasmin is geen bestaand persoon, maar een door de redactie gecreëerd verhaalpersonage. Haar verhaal is een samenvoeging van gesprekken met vijf Iraanse twintigers over de impact van overheidsbeleid en sancties op hun dagelijks leven. Samen met de correspondent is getoetst hoe representatief dit is met het algemene beeld, en op basis daarvan is het scenario geschreven. De impact van de sancties is verder gebaseerd op economische cijfers van onder andere Bloomberg, de Europese Commissie en RVO.
        </p>
        <p class="block">
          <strong>Redactie</strong><br>
          Melvin Captein<br>
          Thomas Erdbrink<br>
          Nick Felix
        </p>
        <p class="block">
          <strong>Vormgeving &amp; code</strong><br>
          Drewes Bos<br>
          Stijn Postmus<br>
          Mariette Twilt
        </p>
      </div>
    </container>
  </div>
</template>
<script>

import ColofonSocial from 'components/ColofonSocial';
import Container from 'components/Container';
import { trackSection } from '../utils/track';

export default {
  components: {
    Container,
    ColofonSocial,
  },
  data() {
    return {
      tracked: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.checkPosition();
    });
  },
  methods: {
    checkPosition() {
      if (this.$el.classList.contains('in-viewport', 'above-viewport')) {
        if (!this.tracked) {
          this.tracked = true;
          trackSection('footer');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .footer {
    width: 100%;
    height: auto;
    margin-top: 200px;
    padding: 50px 0 0;
    position: relative;
    background-color: rgba(0,0,0,0.8);
    z-index: 9;
  }

  .content {
    margin-top: 50px;
  }

  .block {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterSection.vue